import { render, staticRenderFns } from "./PhoneValidation.vue?vue&type=template&id=3340c592&scoped=true&"
import script from "./PhoneValidation.vue?vue&type=script&lang=js&"
export * from "./PhoneValidation.vue?vue&type=script&lang=js&"
import style0 from "./PhoneValidation.vue?vue&type=style&index=0&id=3340c592&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3340c592",
  null
  
)

export default component.exports